import { useEffect, useState } from "react";
import "./AppPTOAccrualCalculator.css";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/appData";
import { EmployeeRecord, PaidTimeOffPolicy } from "winslow-core";
import { apiGetEmployeeRecordsForWorkspace } from "../../../services/EmployeeRecordService";
import toast from "react-hot-toast";
import { toastFail } from "../../../config";
import { erGetCPValue } from "../app-employee-records/employeeRecordUtils";
import { apiGetPaidTimeOffPoliciesForWorkspace } from "../../../services/PaidTimeOffPolicyService";
import { getPTODataForEmployeeRecord, PTOData } from "./ptoUtils";
import DatePicker from "react-datepicker";

type AppPTOAccrualCalculatorProps = {
}

export const AppPTOAccrualCalculator = ({} : AppPTOAccrualCalculatorProps) => {
    const storeUser = useSelector(selectUser);

    const [employeeRecords, setEmployeeRecords] = useState<EmployeeRecord[]>([]);
    const [employeeRecordSelected, setEmployeeRecordSelected] = useState<string | undefined>(undefined);

    const [paidTimeOffPolicies, setPaidTimeOffPolicies] = useState<PaidTimeOffPolicy[]>([]);
    const [ptoPolicySelected, setPtoPolicySelected] = useState<string | undefined>(undefined);

    const [employeePTOData, setEmployeePTOData] = useState<PTOData | undefined>(undefined);
    
    const [asOfDate, setAsOfDate] = useState<Date | null>(null);

    useEffect(() => {
        if (!storeUser?.currentWorkspaceId) {
            return;
        }

        (async () => {
            // Fetch employee records from the server
            const ers = await apiGetEmployeeRecordsForWorkspace(storeUser.currentWorkspaceId || "");

            if (!ers) {
                toast("Cannot load employee records", toastFail);
                return;
            }

            setEmployeeRecords(ers);
            setEmployeeRecordSelected(ers[0].id);

            // fetch policies
            const ptoPolicies = await apiGetPaidTimeOffPoliciesForWorkspace(storeUser.currentWorkspaceId || "");

            if (!ptoPolicies) {
                toast("Cannot load PTO policies", toastFail);
                return;
            }

            setPaidTimeOffPolicies(ptoPolicies);
            setPtoPolicySelected(ptoPolicies[0]?.id);
        })();
    }, [storeUser]);

    useEffect(() => {
        (async () => {
            handleGetPTOData();
        })();
    }, [employeeRecordSelected, ptoPolicySelected, asOfDate]);

    const handleGetPTOData = async () => {
        if (employeeRecordSelected) {
            const ptoData = await getPTODataForEmployeeRecord(
                employeeRecordSelected, 
                ptoPolicySelected === "All" ? undefined : ptoPolicySelected,
                asOfDate,
            );

            if (!ptoData) {
                toast("Cannot load PTO data for employee record", toastFail);
                console.log("[AppPTOAccrualCalculator] Cannot load PTO data for employee record");
                setEmployeePTOData(undefined);
                return;
            }

            setEmployeePTOData(ptoData);
        }
    }


    // console.log("[AppPTOAccrualCalculator] employeeRecords: ", employeeRecords);
    // console.log("[AppPTOAccrualCalculator] employeeRecordSelected: ", employeeRecordSelected);
    // console.log("[AppPTOAccrualCalculator] paidTimeOffPolicies: ", paidTimeOffPolicies);
    console.log("[AppPTOAccrualCalculator] ptoPolicySelected: ", ptoPolicySelected);
       
    return (
        <div className="app-pto-accrual-calculator">
            <div className="app-pto-accrual-calculator-employee">
                <select
                    onChange={(e) => {
                        setEmployeeRecordSelected(e.target.value);
                    }}
                >
                    {employeeRecords.map((record) => {
                        const firstName = erGetCPValue(record, "system-firstName");
                        const lastNme = erGetCPValue(record, "system-lastName");

                        return (
                            <option 
                                key={record.id}
                                value={record.id}
                                selected={employeeRecordSelected === record.id}
                            >
                                {`${firstName} ${lastNme}`}
                            </option>
                        )
                    })}
                </select>
            </div>

            <div className="app-pto-accrual-calculator-policy">
                <select
                    onChange={(e) => {
                        setPtoPolicySelected(e.target.value);
                    }}
                >
                    <option
                        key="all"
                        value={"All"}
                        selected={ptoPolicySelected === undefined}
                    >
                        All
                    </option>

                    {paidTimeOffPolicies.map((ptoPolicy) => {
                        return (
                            <option 
                                key={ptoPolicy.id}
                                value={ptoPolicy.id}
                                selected={ptoPolicySelected === ptoPolicy.id}
                            >
                                {ptoPolicy.name}
                            </option>
                        )
                    })}
                </select>
            </div>

             <DatePicker
                selected={asOfDate || new Date()} 
                dateFormat={"MM/dd/yyyy"}
                
                onChange={(date) => {
                    console.log("DatePicker date", date);
                    setAsOfDate(date as Date | null);
                }}
                className="date-picker-input"
                wrapperClassName="app-date-picker-wrapper"
            />

            <button 
                onClick={handleGetPTOData}
                className="app-pto-accrual-calculator-button"
            >
                Refresh
            </button>

            <div className="app-pto-accrual-calculator-policy-data">
                {employeePTOData && paidTimeOffPolicies &&
                    Array.from(employeePTOData.accrualMap.keys()).map((policyId) => {

                        const ptoPolicy = paidTimeOffPolicies.find((policy) => policy.id === policyId);

                        if (!ptoPolicy) {
                            return null;
                        }   

                        return (
                            <div
                                className="app-pto-accrual-calculator-policy-data-item"
                                key={policyId}
                            >
                                <div className="app-pto-accrual-calculator-policy-data-item-name">

                                    {ptoPolicy.name}
                                </div> 
                                <div className="app-pto-accrual-calculator-policy-data-item-accrual">
                                    Balance: {employeePTOData.accrualMap.get(policyId)}
                                </div>
                                <div className="app-pto-accrual-calculator-policy-data-item-operations">
                                    {employeePTOData.operationsMap.get(policyId)?.map((operation, index) => {
                                        return (
                                            <div
                                                key={index}
                                                className="app-pto-accrual-calculator-policy-data-item-operation"
                                            >
                                                {operation}
                                            </div>
                                        )   
                                    })}
                                </div>
                            </div>
                        )   
                    })
                }
            </div>


        </div>
    )
}